export default {
  apiServerUrl: "https://stopkomat.groupone.pl/"
};
